import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the msDynamicsVerify state domain
 */

const selectMsDynamicsVerifyDomain = state => state.msDynamicsVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectMsDynamicsVerifyDomain, subState => subState.isVerify);

const makeSelectError = () =>
  createSelector(selectMsDynamicsVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
